module.exports = __webpack_public_path__ + "static/00029.17f77099.jpg";